/* eslint-disable consistent-return */
/* eslint-disable object-shorthand */

import axiosInstance from 'src/api/axiosInstance';
// import { calculatePlanPrice } from './calculatePlanPrice';

// ─────────────────────────────────────────────
// FETCH CURRENT PLAN
// ─────────────────────────────────────────────
export const fetchCurrentPlanAPI = async () => {
  const response = await axiosInstance.get('/rest/dynamic-billing/current-plan');
  return response.data;
};
export const fetchBillingPreview =
  async (payload) => {

    const response =
      await axiosInstance.post(
        '/rest/dynamic-billing/billing-preview',
        payload
      );



    return response.data;

  };



// ─────────────────────────────────────────────
// START PAYMENT SERVICE
// ─────────────────────────────────────────────
export const startPaymentService = async ({
  plan,
  userCount,
  paymentMode,
  billingCycle,
  enableUsers,
  currentPlan,
  showToast,
  fetchCurrentPlan,
  handleCloseModals,
  successCallback,
  useWallet,
  onVerifying,
  couponCode,
}) => {
  // const planId = billingCycle === 'annual' ? plan.idAnnual : plan.idMonthly;
  const hasActivePlan =
    ['ACTIVE', 'PAYMENT_SUCCESS']
      .includes(currentPlan?.subscriptionStatus);
  const currentPlanName = currentPlan?.planName?.toUpperCase();
  const selectedPlanName = plan?.name?.toUpperCase();
  const currentPlanCode = (currentPlan?.planCode || currentPlan?.planName || '').toUpperCase();
  const selectedPlanCode = (plan?.code || plan?.id || plan?.name || '').toUpperCase();
  const isSamePlan = Boolean(currentPlanCode && selectedPlanCode && (currentPlanCode === selectedPlanCode || currentPlanCode.includes(selectedPlanCode) || selectedPlanCode.includes(currentPlanCode)));
  const currentBillingCycle = (currentPlan?.billingCycle || '').toUpperCase();
  const selectedBillingCycle = (billingCycle || '').toUpperCase();
  const isCycleChanged = currentBillingCycle !== selectedBillingCycle;

  const finalUserCount = userCount;
  const planCode = selectedPlanName;

  let apiUrl = '';
  let payload = {};

  // =====================================================
  // PLAN CHANGE & CYCLE CHANGE FLOW
  // =====================================================
  if (hasActivePlan && (!isSamePlan || isCycleChanged)) {
    apiUrl = '/rest/dynamic-billing/upgrade-downgrade';
    payload = {
      newPlanCode: selectedPlanName,

      billingCycle:
        billingCycle.toUpperCase(),


      newUserCount: finalUserCount,

      paymentMode,

      paymentType: 'PLAN_CHANGE',

      useWallet,
      couponCode,
    };
  }

  // =====================================================
  // NEW SUBSCRIPTION FLOW
  // =====================================================
  else {
    apiUrl =
      paymentMode === 'AUTO_DEBIT'
        ? '/rest/dynamic-billing/create-auto-debit'
        : '/rest/dynamic-billing/create-order';

    payload = {
      planCode,

      userCount: finalUserCount,

      billingCycle:
        billingCycle.toUpperCase(),

      paymentMode,

      useWallet,
      couponCode,
    };
  }

  // =====================================================
  // API CALL
  // =====================================================
  const apiResponse = await axiosInstance.post(apiUrl, payload);
  const data = apiResponse.data;

  // =====================================================
  // ZERO PAYABLE (WALLET FULLY COVERS COST)
  // =====================================================
  if (Number(data.amount || 0) <= 0) {
    showToast(
      'Subscription activated successfully using wallet credits! ✅',
      'success'
    );

    if (fetchCurrentPlan) {
      await fetchCurrentPlan();
    }

    if (successCallback) {
      successCallback({
        walletPayment: true,
        amount: 0,
        walletUsed: data.walletUsed || 0,
        subscriptionCode: data.subscriptionCode,
      });
    } else {
      handleCloseModals();
    }

    return;
  }


  // =====================================================
  // RAZORPAY OPTIONS
  // =====================================================
  const options = {
    key: data.key,
    currency: data.currency,
    name: 'MeruDesk',
    description: `${plan.name} Plan`,
    prefill: {
      name: data.customerName,
      email: data.customerEmail,
      contact: data.customerContact,
    },
    theme: {
      color: '#3399cc',
    },

    // ===================================================
    // PAYMENT SUCCESS
    // ===================================================
    handler: async (response) => {
      try {
        if (onVerifying) onVerifying(true);
        else if (showToast) showToast('Payment received! Verifying and activating your plan, please wait...', 'info');

        await axiosInstance.post(
          '/rest/dynamic-billing/verify-payment',
          {

            paymentMode:
              paymentMode === 'AUTO_DEBIT'
                ? 'AUTO_DEBIT'
                : 'MANUAL',

            razorpayPaymentId:
              response.razorpay_payment_id,

            razorpaySignature:
              response.razorpay_signature,

            // MANUAL FLOW
            razorpayOrderId:
              paymentMode === 'MANUAL'
                ? response.razorpay_order_id
                : null,

            // AUTO DEBIT FLOW
            razorpaySubscriptionId:
              paymentMode === 'AUTO_DEBIT'
                ? (
                  response.razorpay_subscription_id
                  || data.subscriptionId
                  || data.razorpaySubscriptionId
                )
                : null,
          }
        );

        if (
          paymentMode === 'AUTO_DEBIT' &&
          hasActivePlan
        ) {

          showToast(
            'Authorization completed successfully. Your new plan is now active! ✅',
            'success'
          );

        } else {

          showToast(
            'Payment Successful ✅',
            'success'
          );
        }

        if (fetchCurrentPlan) {
          await fetchCurrentPlan();
        }
        if (successCallback) {
          successCallback({
            razorpayPaymentId: response.razorpay_payment_id,
            razorpayOrderId: response.razorpay_order_id,
            razorpaySubscriptionId: response.razorpay_subscription_id,
          });
        } else {
          handleCloseModals();
        }
      } catch (e) {
        if (onVerifying) onVerifying(false);
        console.error(e);
        showToast('Payment verification failed', 'error');
      }
    },

    // ===================================================
    // PAYMENT CANCELLED
    // ===================================================
    modal: {
      async ondismiss() {

        try {

          await axiosInstance.post(
            '/rest/dynamic-billing/cancel-pending-replacement'
          );

        } catch (e) {

          console.error(e);
        }

        showToast(
          'Subscription update cancelled',
          'warning'
        );
      },
    },
  };

  // =====================================================
  // MANUAL PAYMENT
  // =====================================================
  if (paymentMode === 'MANUAL') {
    options.amount =
      Math.round(
        Number(data.amount || 0) * 100
      );
    options.order_id = data.orderId;
  }

  // =====================================================
  // AUTO DEBIT
  // =====================================================
  if (paymentMode === 'AUTO_DEBIT') {

    options.subscription_id =
      data.subscriptionId
      || data.razorpaySubscriptionId;

    if (!options.subscription_id) {

      showToast(
        'Subscription ID not received from server',
        'error'
      );

      return;
    }
  }
  // =====================================================
  // OPEN RAZORPAY
  // =====================================================
  if (
    typeof window === 'undefined'
    || !window.Razorpay
  ) {

    showToast(
      'Razorpay SDK failed to load',
      'error'
    );

    return;
  }


  // =====================================================
  // ZERO PAYMENT FLOW
  // =====================================================

  if (Number(data.amount || 0) <= 0) {

    showToast(
      'Plan updated successfully ✅',
      'success'
    );

    if (fetchCurrentPlan) {
      await fetchCurrentPlan();
    }

    if (successCallback) {

      successCallback({
        walletPayment: true,
        amount: 0,
        walletUsed:
          data.walletUsed || 0,
      });

    } else {

      handleCloseModals();
    }

    return;
  }


  const rzp =
    new window.Razorpay(options);

  rzp.open();
};



// ─────────────────────────────────────────────
// ADD USERS TO EXISTING PLAN SERVICE
// ─────────────────────────────────────────────
export const addUsersToExistingPlanService = async ({
  plan,
  userCount,
  currentPlan,
  showToast,
  fetchCurrentPlan,
  handleCloseModals,
  successCallback,
  useWallet,
  onVerifying,
  couponCode,
}) => {

  // ============================================
  // CREATE ADD USER REQUEST
  // ============================================


  const response = await axiosInstance.post(
    '/rest/dynamic-billing/add-users',
    {
      additionalUsers: userCount,
      useWallet,
      paymentMode:
        currentPlan?.paymentMode || 'MANUAL',
      couponCode,
    }
  );

  const data = response.data;
  const isAutoDebit = false;


  // ============================================
  // WALLET ONLY FLOW
  // ============================================

  if (
    Number(data.amount || 0) <= 0
  ) {

    showToast(
      'Users Added Successfully ✅',
      'success'
    );

    if (fetchCurrentPlan) {
      await fetchCurrentPlan();
    }

    if (successCallback) {

      successCallback({
        walletPayment: true,
        subscriptionCode: data.subscriptionCode,
        walletUsed: data.walletUsed,
      });

    } else {

      handleCloseModals();
    }

    return;
  }

  // ============================================
  // RAZORPAY OPTIONS
  // ============================================

  const options = {

    key:
      data.key,

    currency:
      data.currency || 'INR',

    name:
      'MeruDesk',

    description:
      'Additional Users',

    theme: {
      color: '#3399cc',
    },

    handler: async (paymentResponse) => {

      try {
        if (onVerifying) onVerifying(true);
        else if (showToast) showToast('Payment received! Adding seats, please wait...', 'info');

        await axiosInstance.post(
          '/rest/dynamic-billing/verify-payment',
          {
            paymentMode: isAutoDebit ? 'AUTO_DEBIT' : 'MANUAL',
            razorpayPaymentId:
              paymentResponse.razorpay_payment_id,
            razorpaySignature:
              paymentResponse.razorpay_signature,
            razorpayOrderId:
              paymentResponse.razorpay_order_id || data.orderId || null,
            razorpaySubscriptionId:
              paymentResponse.razorpay_subscription_id ||
              data.subscriptionId ||
              data.razorpaySubscriptionId ||
              currentPlan?.razorpaySubscriptionId ||
              null,
            paymentType: 'ADD_USERS',
          }
        );

        // Open mandate authorization if provided
        if (data.authorizationUrl) {

          window.open(
            data.authorizationUrl,
            '_blank'
          );
        }

        showToast(
          'Additional users added successfully. Please allow a few moments for the changes to reflect. ✅',
          'success'
        );

        if (fetchCurrentPlan) {
          await fetchCurrentPlan();
        }

        if (successCallback) {

          successCallback({
            razorpayPaymentId:
              paymentResponse.razorpay_payment_id,
            userCount,
            planName: plan.name,
            paymentMode: isAutoDebit ? 'AUTO_DEBIT' : 'MANUAL',
          });

        } else {

          handleCloseModals();
        }

      } catch (e) {

        console.error(e);

        showToast(
          'Payment verification failed',
          'error'
        );
      }
    },

    modal: {

      async ondismiss() {

        try {

          await axiosInstance.post(
            '/rest/dynamic-billing/cancel-pending-replacement'
          );

        } catch (e) {

          console.error(
            '[ADD_USERS_CANCEL]',
            e
          );
        }

        showToast(
          'Subscription update cancelled',
          'warning'
        );
      },
    },
  };

  // ============================================
  // RAZORPAY ORDER / SUBSCRIPTION SETUP
  // ============================================

  if (data.orderId) {
    options.order_id = data.orderId;
    options.amount = Math.round(Number(data.amount || 0) * 100);
  } else if (isAutoDebit && (data.subscriptionId || data.razorpaySubscriptionId)) {
    options.subscription_id =
      data.subscriptionId || data.razorpaySubscriptionId;
  } else {
    options.order_id = data.orderId;
    options.amount = Math.round(Number(data.amount || 0) * 100);
  }

  // ============================================
  // SDK CHECK
  // ============================================

  if (
    typeof window === 'undefined'
    || !window.Razorpay
  ) {

    showToast(
      'Razorpay SDK failed to load',
      'error'
    );

    return;
  }


  // ============================================
  // OPEN RAZORPAY
  // ============================================

  const rzp =
    new window.Razorpay(
      options
    );

  rzp.open();
};


// ─────────────────────────────────────────────
// REMOVE USERS SERVICE
// ─────────────────────────────────────────────
export const removeUsersFromExistingPlanService = async ({
  removeUsers,
  showToast,
  fetchCurrentPlan,
  handleCloseModals,
  successCallback,
}) => {

  const response = await axiosInstance.post(
    '/rest/dynamic-billing/remove-users',
    { removeUsers }
  );

  const data = response.data;

  showToast(
    `Wallet credited successfully ₹${data.walletUsed}`,
    'success'
  );

  let updatedPlan = null;

  if (fetchCurrentPlan) {
    updatedPlan = await fetchCurrentPlan();
  }


  if (successCallback) {

    successCallback({
      paymentMode: 'REMOVE_USERS',
      removeCount: removeUsers,
      walletCredited: data.walletCreditAmount,
    });
  } else {

    handleCloseModals();
  }

  return data;
};


export const renewSubscriptionService = async ({
  paymentMode,
  useWallet,
  showToast,
  fetchCurrentPlan,
  handleClose,
  onVerifying,
}) => {

  const response = await axiosInstance.post(
    '/rest/dynamic-billing/renew',
    {
      paymentMode,
      useWallet,
    }
  );

  const data = response.data;


  // ==========================================
  // WALLET ONLY FLOW
  // ==========================================

  if (Number(data.amount || 0) <= 0) {

    showToast(
      'Subscription renewed successfully ✅',
      'success'
    );

    if (fetchCurrentPlan) {
      await fetchCurrentPlan();
    }

    if (handleClose) {
      handleClose();
    }

    return data;
  }

  // ==========================================
  // SDK CHECK
  // ==========================================

  if (
    typeof window === 'undefined'
    || !window.Razorpay
  ) {

    showToast(
      'Razorpay SDK failed to load',
      'error'
    );


    return;
  }

  // ==========================================
  // RAZORPAY
  // ==========================================

  const options = {

    key: data.key,

    amount:
      Math.round(
        Number(data.amount) * 100
      ),

    currency:
      data.currency || 'INR',

    order_id:
      data.orderId,

    name:
      'MeruDesk',

    description:
      'Subscription Renewal',

    theme: {
      color: '#16a34a',
    },

    handler: async (paymentResponse) => {

      try {
        if (onVerifying) onVerifying(true);
        else if (showToast) showToast('Payment received! Renewing subscription, please wait...', 'info');

        await axiosInstance.post(
          '/rest/dynamic-billing/verify-payment',
          {
            paymentMode: 'MANUAL',

            razorpayPaymentId:
              paymentResponse.razorpay_payment_id,

            razorpaySignature:
              paymentResponse.razorpay_signature,

            razorpayOrderId:
              paymentResponse.razorpay_order_id,
          }
        );

        showToast(
          'Subscription renewed successfully ✅',
          'success'
        );

        if (fetchCurrentPlan) {
          await fetchCurrentPlan();
        }

        if (handleClose) {
          handleClose();
        }

      } catch (e) {
        if (onVerifying) onVerifying(false);
        console.error(e);

        showToast(
          'Payment verification failed',
          'error'
        );
      }
    },

    modal: {
      ondismiss() {

        showToast(
          'Renewal cancelled',
          'warning'
        );
      },
    },
  };

  const rzp =
    new window.Razorpay(options);

  rzp.open();

  return data;
};

export const contactSalesService = async (formData) => {
  const response = await axiosInstance.post('/rest/dynamic-billing/contact-sales', formData);
  return response.data;
};